import React from 'react'
import type { ProductScanConfig } from '../config'
import { findProductConfig } from '../config'
import type { ProductScanResult } from '../useProductScan'
import { formatStepImageUrl } from 'util/beaker2-step-image-url'
import ScanBox from './ScanBox'
// @ts-expect-error SCSS modules are untyped in this project
import * as styles from '../product-scan.module.scss'

export type SuccessScreenProps = {
  config: ProductScanConfig
  result: ProductScanResult
  // No action wired yet (reward wiring is BR-5573): omit and both CTA buttons are not rendered.
  onCta?: () => void
}

const SuccessScreen = ({ config, result, onCta }: SuccessScreenProps) => {
  const product = result.product
  const matchedConfig = findProductConfig(config.products, product?.upc)

  return (
    <div className={styles.step}>
      <h2 className={`${styles.screenTitle} ${styles.centered}`}>{config.successTitle}</h2>
      <div className={styles.successMark} aria-hidden="true">
        ✓
      </div>
      {config.validScanHeadline && (
        <h1 className={`${styles.headline} ${styles.centered}`}>{config.validScanHeadline}</h1>
      )}
      {config.validScanBody && (
        <p className={`${styles.introCopy} ${styles.centered}`}>{config.validScanBody}</p>
      )}

      <ScanBox backgroundColor={config.boxBackgroundColor} textColor={config.boxTextColor}>
        <div className={styles.productCard}>
          {product?.imageUrl && (
            <img className={styles.productImage} src={formatStepImageUrl(product.imageUrl)} alt={product.productName || ''} />
          )}
          {matchedConfig?.category && (
            <span className={styles.categoryTag}>{matchedConfig.category}</span>
          )}
          {product?.productName && <h3>{product.productName}</h3>}
          {matchedConfig?.description && <p>{matchedConfig.description}</p>}
        </div>

        {config.unlockValue && (
          <div className={styles.unlockRow}>
            <span aria-hidden="true">✓</span>
            <div>
              <div className={styles.unlockLabel}>{config.unlockLabel}</div>
              <div className={styles.unlockValue}>{config.unlockValue}</div>
            </div>
          </div>
        )}

        {/* Display-only copy + the step's normal next-step control — no instant-win/InComm
            wiring here (captain's decision: wired to a real reward step later, its own ticket). */}
        {config.rewardHeadline && (
          <div className={styles.rewardCard}>
            <h4>{config.rewardHeadline}</h4>
            {config.rewardBody && <p>{config.rewardBody}</p>}
            {config.rewardCtaText && onCta && (
              <button type="button" className={styles.rewardCta} onClick={onCta}>
                {config.rewardCtaText}
              </button>
            )}
          </div>
        )}
      </ScanBox>

      {onCta && (
        <button type="button" className={styles.cta} onClick={onCta}>
          {config.successCtaText}
        </button>
      )}
    </div>
  )
}

export default SuccessScreen
